import React from 'react';
import { PageHero } from '../components/PageHero';
import { About } from '../components/About';
export function AboutPage() {
  return <>
      <PageHero breadcrumb="About" title="About Us" subtitle="The African Union Commission — bridging Africa and the world." data-id="element-283" />
      <About data-id="element-284" />
    </>;
}